import { PropsWithChildren } from "react";
import { styles } from "../../../theme/styles";
import {
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface Props {
  id?: string;
  description?: string[];
}

export const ImageAi = ({ id, description }: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Grid item md={12} xs={12} spacing={0} style={{ padding: 0 }}>
      <Paper
        style={
          isDesktop
            ? { ...styles.card, height: "750px" }
            : { ...styles.card, ...styles.mobileCard }
        }
      >
        <Typography
          variant="h5"
          style={{
            padding: "0",
            display: "flex",
            marginLeft: "10%",
            marginRight: "9%",
            alignItems: "center",
            justifyContent: "center",
            width: "90%",
            height: "100%",
          }}
        ></Typography>
        {description &&
          description.map((item, index) => (
            <Typography
              key={index} // Use uma chave única para ajudar o React a identificar quais itens mudaram, foram adicionados ou removidos
              variant="body1"
              style={{
                padding: "0",
                color: "#353740",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                height: "100%",
              }}
            >
              {item}
            </Typography>
          ))}
      </Paper>
    </Grid>
  );
};
